import { nextStateHistory, StateHistory } from 'aurelia-store';
import cloneDeep from 'lodash-es/cloneDeep';

import { AppState } from '~/app-store';
import { EntitySearchType } from '~/components/entity-search/entity-type';
import { EntityTypeUtils } from '~/components/entity-search/entity-type-util';
import { ENTITY_SEARCH_HISTORY_LIMIT } from '~/constants';
import { EntityType } from '~/models/entities/entity-type';

/**
 * Add entity to history
 * NOTE: Save to back end instead of front end (localStorage)
 * To be done with WEBUI-1254
 */
const AddEntityToHistory = (
	stateHistory: StateHistory<AppState>,
	entity: EntitySearchType,
) => {
	const newState: AppState = cloneDeep(stateHistory.present);
	if (!entity || !entity.entityType) {
		if (DEVELOPMENT) {
			throw new Error(
				'Developer Bug: Cannot pass empty entity or entity with no set type.',
			);
		}
		return nextStateHistory<AppState>(stateHistory, newState);
	}

	// Find existing entity type in history
	const NoEntityFound = -1;
	let entityIndex: number = NoEntityFound;

	// Find matching entity
	{
		const searchHistoryList =
			stateHistory.present.navigation.searchHistory[entity.entityType];
		if (searchHistoryList !== undefined) {
			for (let i = 0; i < searchHistoryList.length; i++) {
				if (
					EntityTypeUtils.getUniqueID(entity) ===
					EntityTypeUtils.getUniqueID(searchHistoryList[i])
				) {
					entityIndex = i;
					break;
				}
			}
		}
	}

	let newStateSearchHistoryList =
		newState.navigation.searchHistory[entity.entityType];
	if (newStateSearchHistoryList === undefined) {
		// NOTE: Jake: 2019-09-11
		// If no array exists yet, this must mean a new entity type was introduced
		// and that local storage is using an old verison.
		newState.navigation.searchHistory[entity.entityType] = [];
		newStateSearchHistoryList =
			newState.navigation.searchHistory[entity.entityType];
	}

	// remove the entity if it exists
	if (entityIndex !== NoEntityFound) {
		newStateSearchHistoryList.splice(entityIndex, 1);
	}
	// Add to front
	newStateSearchHistoryList.unshift(entity);

	// Trimming extra entities / cap at fixed limit
	if (
		newStateSearchHistoryList !== undefined &&
		newStateSearchHistoryList.length > ENTITY_SEARCH_HISTORY_LIMIT
	) {
		newStateSearchHistoryList.length = ENTITY_SEARCH_HISTORY_LIMIT;
	}

	return nextStateHistory<AppState>(stateHistory, newState);
};

export const EntitySearchActions = {
	AddEntityToHistory,
};
